
import { defineComponent } from "vue";
import CompoundCategoryForm from "./Form.vue";

export default defineComponent({
  components: {
    CompoundCategoryForm,
  },
  setup() {
    return {};
  },
});
